var _circle, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlankHeadshot = function SvgBlankHeadshot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 178,
    height: 178,
    fill: "none",
    viewBox: "0 0 178 178"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 89,
    r: 89,
    fill: "#F0F0F0"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 178,
    height: 178,
    x: 0,
    y: 0,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 89,
    r: 89,
    fill: "#F0F0F0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#CCC",
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 72,
    r: 36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 195,
    r: 75
  }))));
};
export { SvgBlankHeadshot as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc4IiBoZWlnaHQ9IjE3OCIgdmlld0JveD0iMCAwIDE3OCAxNzgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9Ijg5IiBjeT0iODkiIHI9Ijg5IiBmaWxsPSIjRjBGMEYwIi8+CjxtYXNrIGlkPSJtYXNrMCIgbWFzay10eXBlPSJhbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjE3OCIgaGVpZ2h0PSIxNzgiPgo8Y2lyY2xlIGN4PSI4OSIgY3k9Ijg5IiByPSI4OSIgZmlsbD0iI0YwRjBGMCIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazApIj4KPGNpcmNsZSBjeD0iODkiIGN5PSI3MiIgcj0iMzYiIGZpbGw9IiNDQ0NDQ0MiLz4KPGNpcmNsZSBjeD0iODkiIGN5PSIxOTUiIHI9Ijc1IiBmaWxsPSIjQ0NDQ0NDIi8+CjwvZz4KPC9zdmc+Cg==";